import { CapsuleManifest, LegacyManifest } from '../../../types/capsule';
import { getManifestUrl } from '../../../lib/manifest';

export type CapsuleManifestResponse = CapsuleManifest | LegacyManifest;

export function isCapsuleManifest(data: CapsuleManifestResponse): data is CapsuleManifest {
  return 'capsules' in data;
}

export function isLegacyManifest(data: CapsuleManifestResponse): data is LegacyManifest {
  return 'scores' in data;
}

export async function fetchCapsuleManifest(bustCache = false): Promise<CapsuleManifestResponse> {
  const response = await fetch(getManifestUrl(bustCache), { cache: 'no-store' });
  if (!response.ok) {
    throw new Error('Failed to fetch manifest');
  }
  const data = await response.json();
  if (!data || (typeof data !== 'object')) {
    throw new Error('Invalid manifest response');
  }
  return data as CapsuleManifestResponse;
}
